<template>
  <div class="wapper">
    <img class="logo"
         :src="require(`../assets/${$platform}_logo.png`)"
         alt="logo" v-if="!channelInfo.logoUrl">
    <img class="logo"
         :src="channelInfo.logoUrl"
         alt="logo" v-if="channelInfo.logoUrl">
    <div class="content-wapper">
      <div class="title"
           v-if="loginUser != null && systemMenus != null">
        <div class="header">
          <img :src="loginUser.avatar || 'https://rs.juyoufuli.com/assets/staffs/timg.jpg'" v-if="channelCode  == 'QD0000'">
          <div>
            <span class="name">Hi~ {{loginUser.name}}</span>
            <span v-if="channelCode  == 'QD0000'">欢迎登录{{$platform=='fulufuxi'?'福禄福喜':'聚优福利'}}管理平台</span>
            <span v-if="channelCode !== 'QD0000'">欢迎使用{{channelInfo.channelName}}业务管理系统</span>
            <p class="red" v-if="channelCode !== 'QD0000'">{{ channelInfo.describe }}</p>
            <p style="margin-top: 5px;">检测到您有以下系统权限，请选择您要访问的系统</p>
            <a href="javascript:;"
               class="link-a out icon icon-admin-logout baseColor"
               @click="loginOut">退出登录</a>
          </div>
        </div>
        <div class="shortcut-wapper">
          <label>快捷方式</label>
          <ul>
            <li>
              <a class="link-a icon icon-admin-back baseColor"
              
                 href="javascript:;"
                 @click="shortcut(request.crm_admin_address + '/stored-order-list')">储值订单</a>
            </li>
            <li>
              <a class="link-a icon icon-admin-back baseColor"
                 href="javascript:;"
                 @click="shortcut(request.general_address + '/user/my-approval')">我的审批</a>
            </li>
          </ul>
        </div>
        <ul class="menu-wapper">
          <li @click="cutSystem(menu)"
              v-for="menu in systemMenus"
              :key="menu.id">
            <div class="menu-item">
                <div class="menu-icon baseColor" v-if="menu.iconClass">
                    <i class="icon" :class="menu.iconClass"></i>
                </div>
              <img :src="menu.iconAddress" v-else>
              <label>{{menu.name}}</label>
              <span>{{menu.describe}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div v-else
           class="not-power">未检测到您的系统权限，如有需要请联系管理员设置</div>
    </div>
  </div>
</template>

<script>
import _menu from '@/service/menu-service'
import _channel from '@/service/channel-service'
import _userinfo from '@/service/userinfo-service'
import _cookies from 'js-cookie'
import _constant from '@/utils/constant'
import _request from '@/utils/request'
import config from '@/config/config'
import { Notification,MessageBox,Loading } from 'element-ui'

export default {
  data () {
    return {
        systemMenus: null,
        isLogin: null,
        loginUser: null,
        request: _request,
        platform: config.platform,
        channelInfo:{
          describe:null,
          channelName:null,
          logoUrl:null,
          channelLoginCode:null,
          channelStatus:null,
          id:null
        },
        channelLoginCode:this.$route.query.channelLoginCode,
        channelCode:null,
        juyou_passport_address: config.juyou_passport_address
    }
  },
  mounted () {
    // 查询登录用户
    _userinfo.getLoginUser(response => {
      this.isLogin = true
      this.loginUser = response
      this.channelCode = response.channelCode
      _channel.getChannelInfo({
        channelCode:response.channelCode
      }, (response) => {
        this.channelLoginCode = response.channelLoginCode
        this.channelInfo = response
      })
      // 查询用户系统级别菜单
      var isSystem = 1;
      _menu.getMenuTreeList(isSystem, null, response => {
        response.forEach((item,index)=>{
            let _class = item.url.match(/\/\/(\w+\-?\w+)\./)[1];
            if(_class.indexOf('-admin')>0){
                _class = _class.replace('-admin','')
            }
            if(_class) item.iconClass = `icon-admin-${_class}`
        })
        this.systemMenus =response;
        console.log(this.systemMenus)
      })
    })
  },
  methods: {
    // 切换系统
    cutSystem (menu) {
      window.location.replace(menu.url)
    },
    // 登出
    loginOut () {
      _userinfo.loginOut(() => {
        _cookies.remove(_constant.loginKey);
        if(this.channelCode !== 'QD0000') {
          this.$router.replace({
            path: '/login?channelLoginCode='+this.channelLoginCode
          })
        }else {
          this.$router.replace({
            path: '/login'
          })
        }
      })
    },
    shortcut (address) {
      window.location.replace(address)
    }
  }
}
</script>

<style scoped>
.logo {
  width: 120px;
  height: 29px;
  position: absolute;
  top: 15px;
  left: 0px;
}
.wapper {
  width: 1188px;
  height: 100%;
  background-repeat: no-repeat;
  background-position: bottom left;
  font-size: 14px;
  padding: 70px 0px;
  margin: 0 auto;
  position: relative;
}
.content-wapper {
  background: #fff;
  border-radius: 5px;
  border: 1px solid #bcbcbc;
}
.content-wapper .title {
  padding: 30px;
}
.name {
  font-weight: bold;
  font-size: 18px;
  margin-right: 15px;
}
.shortcut-wapper {
  border-top: 1px solid #bcbcbc;
  padding: 30px 0;
}
.shortcut-wapper label {
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
}
.shortcut-wapper li {
  display: inline-block;
  padding-right: 15px;
  position: relative;
}
.shortcut-wapper li a{
    font-size: 14px;
}
.menu-wapper {
  padding-top: 30px;
  border-top: 1px solid #bcbcbc;
  min-height: 420px;
}
.menu-wapper li {
  width: 280px;
  height: 195px;
  font-weight: bold;
  display: inline-block;
  padding: 15px;
  padding-left: 0;
  padding-bottom: 0;
  vertical-align: top;
}
.menu-wapper .menu-item {
  height: 100%;
  width: 100%;
  background: #fafafa;
  padding: 15px;
  cursor: pointer;
  text-align: center;
}
.menu-item:hover {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}
.menu-item label {
  font-size: 18px;
  font-weight: normal;
  display: block;
  cursor: pointer;
  margin-top: 15px;
}
.menu-item span {
  display: block;
  font-size: 14px;
  font-weight: normal;
  color: #787878;
  margin-top: 15px;
}
.menu-item img {
  height: 35px;
}
.not-power {
  padding: 30px;
}
.link-a {
  color: #00a862;
  display: inline-block;
  padding: 10px 0;
}
.out {
  position: relative;
  font-size: 14px;
}
.out::before {
    font-size: 16px;
    margin-right: 4px;
    font-weight: 600;
}
.header {
  padding-bottom: 30px;
}
.header div,
img {
  display: inline-block;
}
.header img {
  width: 80px;
  vertical-align: top;
  margin-right: 30px;
}
.menu-icon{
    font-size: 40px;
}

.red{
  color: red;
  margin: 10px 0;
  max-width: 1110px;
  line-height: 25px;
}
</style>